/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KpiTrendEnum } from './KpiTrendEnum';
import {
    KpiTrendEnumFromJSON,
    KpiTrendEnumFromJSONTyped,
    KpiTrendEnumToJSON,
    KpiTrendEnumToJSONTyped,
} from './KpiTrendEnum';

/**
 * An objectif (goal) card displaying a single metric
 * @export
 * @interface ObjectifCardDto
 */
export interface ObjectifCardDto {
    /**
     * Unique identifier for this objectif
     * @type {string}
     * @memberof ObjectifCardDto
     */
    id: string;
    /**
     * Display title for the objectif
     * @type {string}
     * @memberof ObjectifCardDto
     */
    title: string;
    /**
     * Current value of the objectif
     * @type {number}
     * @memberof ObjectifCardDto
     */
    value: number;
    /**
     * Unit to display (e.g., "EUR", "%", empty for count)
     * @type {string}
     * @memberof ObjectifCardDto
     */
    unit?: string;
    /**
     * Format hint (e.g., "currency", "percentage", "number")
     * @type {string}
     * @memberof ObjectifCardDto
     */
    format?: string;
    /**
     * Icon identifier to display
     * @type {string}
     * @memberof ObjectifCardDto
     */
    icon?: string;
    /**
     * Color for the objectif card (hex format)
     * @type {string}
     * @memberof ObjectifCardDto
     */
    color?: string;
    /**
     * Previous period value for comparison
     * @type {number}
     * @memberof ObjectifCardDto
     */
    previousValue?: number;
    /**
     * Label describing the comparison period
     * @type {string}
     * @memberof ObjectifCardDto
     */
    comparisonLabel?: string;
    /**
     * 
     * @type {KpiTrendEnum}
     * @memberof ObjectifCardDto
     */
    trend?: KpiTrendEnum;
    /**
     * Percentage change from previous period
     * @type {number}
     * @memberof ObjectifCardDto
     */
    trendPercentage?: number;
    /**
     * Display order in the dashboard
     * @type {number}
     * @memberof ObjectifCardDto
     */
    order?: number;
}



/**
 * Check if a given object implements the ObjectifCardDto interface.
 */
export function instanceOfObjectifCardDto(value: object): value is ObjectifCardDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ObjectifCardDtoFromJSON(json: any): ObjectifCardDto {
    return ObjectifCardDtoFromJSONTyped(json, false);
}

export function ObjectifCardDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ObjectifCardDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'value': json['value'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'format': json['format'] == null ? undefined : json['format'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'color': json['color'] == null ? undefined : json['color'],
        'previousValue': json['previousValue'] == null ? undefined : json['previousValue'],
        'comparisonLabel': json['comparisonLabel'] == null ? undefined : json['comparisonLabel'],
        'trend': json['trend'] == null ? undefined : KpiTrendEnumFromJSON(json['trend']),
        'trendPercentage': json['trendPercentage'] == null ? undefined : json['trendPercentage'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function ObjectifCardDtoToJSON(json: any): ObjectifCardDto {
    return ObjectifCardDtoToJSONTyped(json, false);
}

export function ObjectifCardDtoToJSONTyped(value?: ObjectifCardDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'value': value['value'],
        'unit': value['unit'],
        'format': value['format'],
        'icon': value['icon'],
        'color': value['color'],
        'previousValue': value['previousValue'],
        'comparisonLabel': value['comparisonLabel'],
        'trend': KpiTrendEnumToJSON(value['trend']),
        'trendPercentage': value['trendPercentage'],
        'order': value['order'],
    };
}

